import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {TransactionalNames} from '../enums/TransactionalNames.js';
import {Statistics} from './statistics.js';
import {StoreItem, StoreManagerData} from '../types/StoreManagerData.js';
import {DataManager} from '../classes/DataManager.js';
import {StoreItemTypes} from '../enums/StoreManagerEnums.js';

export class StoreManager extends Component {
    static TypeName = 'store-manager';

    // Singleton
    private static _instance: StoreManager;
    static get instance(): StoreManager {
        return StoreManager._instance;
    }

    @property.int(1000)
    missionSkipCost = 1000;

    itemMap: Map<TransactionalNames, StoreItem> = new Map();

    init() {
        if (StoreManager._instance) {
            console.error('There can only be one instance of StoreManager Component');
        }
        StoreManager._instance = this;
        DataManager.instance
            .loadData<StoreManagerData>('data/StoreData.bin')
            .then((data) => {
                data.storeItems.forEach((storeItem) => {
                    const item = storeItem as StoreItem;
                    this.itemMap.set(item.itemStat, item);
                });
            });
    }

    getUpgradeLevel(stat: TransactionalNames) {
        const currLevel = Statistics.instance.getTransactional(stat);
        return currLevel;
    }

    /**
     * Get amount to add via stat
     */
    getAmountToAdd(stat: TransactionalNames, costIndex: number): number {
        let amount = 0;
        const item = this.itemMap.get(stat);
        if (item.inventoryAmounts.length - 1 >= costIndex) {
            amount = item.inventoryAmounts[costIndex];
        }
        return amount;
    }

    /**
     * Get coin cost by searching list of stats
     */
    getInventoryCost(stat: TransactionalNames, costIndex: number) {
        let coinCost = 0;
        const item = this.itemMap.get(stat);

        if (item.itemCosts.length - 1 >= costIndex) {
            coinCost = item.itemCosts[costIndex];
        }

        return coinCost;
    }

    /**
     * Get coin cost by searching list of stats
     */
    getCoinCost(stat: TransactionalNames) {
        let coinCost = 0;

        const item = this.itemMap.get(stat);

        const upgradeLevel = Statistics.instance.getTransactional(stat);

        if (upgradeLevel >= item.itemCosts.length) {
            coinCost = -1;
        } else {
            coinCost = item.itemCosts[upgradeLevel];
        }

        return coinCost;
    }

    /**
     * Get highest upgrade level for a type of object (for achievement)
     */
    getHighestUpgradeLevel(type: StoreItemTypes): number {
        let highestUpgrade = 0;

        this.itemMap.forEach((item) => {
            if (item.itemType === type) {
                const temp = this.getUpgradeLevel(item.itemStat);
                if (temp > highestUpgrade) {
                    highestUpgrade = temp;
                }
            }
        });
        return highestUpgrade;
    }

    /**
     * Get number of things unlocked of a type (for achievement)
     */
    getNumberOfMalwear(): number {
        let numberMalwear = 0;

        this.itemMap.forEach((item) => {
            if (item.itemType == StoreItemTypes.StoreMalwear) {
                if (this.getUpgradeLevel(item.itemStat) > 0) {
                    numberMalwear++;
                }
            }
        });
        return numberMalwear;
    }
}
